var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28574 12.022C5.00144 11.9945 3.88379 11.2986 3.26491 10.2783C3.6661 10.2757 4.06073 10.2282 4.43101 10.1283L4.39968 9.15544C3.00729 8.87419 1.90212 7.79385 1.60437 6.42148C2.00468 6.54825 2.43015 6.6235 2.86289 6.6316L4.58595 6.66389L3.14773 5.71442C2.19319 5.08426 1.55618 3.99763 1.55618 2.77662C1.55618 2.37953 1.62345 1.999 1.74685 1.64132C3.83378 3.86439 6.75348 5.30093 10.019 5.45819L10.6782 5.48993L10.5304 4.8468C10.4735 4.59908 10.4483 4.3303 10.4483 4.03815C10.4483 2.09476 12.0423 0.5 14.0342 0.5C15.06 0.5 15.9997 0.929548 16.6584 1.62213L16.8478 1.82127L17.1174 1.76809C17.5589 1.68102 17.9888 1.56285 18.4047 1.41425C18.1621 1.68231 17.8778 1.91407 17.5608 2.10097L17.8769 3.0278C18.1461 2.99403 18.4121 2.94914 18.6745 2.89313C18.4126 3.14191 18.1326 3.37167 17.8344 3.58068L17.6079 3.7394L17.622 4.01562C17.6304 4.1819 17.6363 4.34506 17.6363 4.512C17.6363 9.62485 13.695 15.5 6.49943 15.5C4.99624 15.5 3.56873 15.2104 2.26564 14.6805C3.88227 14.4866 5.36601 13.8558 6.58071 12.9175L7.70106 12.0522L6.28574 12.022Z",
    stroke: "#787676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f1e66eea49cc819c430e79a431896167.svg";
export { ForwardRef as ReactComponent };